document.addEventListener("DOMContentLoaded", function () {

    // Notices date picker (converted from dateRangePicker/moment to Litepicker)
    if (document.querySelectorAll('.notice-date').length > 0) {
        function fmtYMD(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }

        document.querySelectorAll('.notice-date').forEach(function(el){
            try {
                if (typeof Litepicker === 'undefined') return;

                var startInput = document.getElementById('noticeStartDate');
                var endInput = document.getElementById('noticeEndDate');
                console.log('Initializing Litepicker for notices with startInput:', startInput, 'endInput:', endInput);
                var picker = new Litepicker({
                    element: el,
                    singleMode: false,
                    autoApply: true,
                    format: 'DD MMM YYYY'
                });

                if (startInput && endInput && startInput.value && endInput.value) {
                    try {
                        var s = startInput.value.split(' ')[0];
                        var e = endInput.value.split(' ')[0];
                        console.log('Setting initial date range for notices:', s, e);
                        var sDate = parseUKDate(s);
                        var eDate = parseUKDate(e);
                        console.log('Parsed initial date range for notices:', sDate, eDate);
                        try { picker.setDateRange(sDate, eDate); } catch (err) { /* ignore */ }
                        if (!isNaN(sDate.getTime()) && !isNaN(eDate.getTime())) {
                            el.innerHTML = sDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + eDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
                        }
                    } catch (err) { /* ignore */ }
                }

                picker.on('selected', function(startDate, endDate){
                    var sd = new Date(startDate.getTime());
                    var ed = new Date(endDate.getTime());
                    if (!isNaN(sd.getTime()) && !isNaN(ed.getTime())) {
                        el.innerHTML = sd.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + ed.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
                        if (startInput) startInput.value = fmtYMD(sd) + ' 00:00:00';
                        if (endInput) endInput.value = fmtYMD(ed) + ' 23:59:59';
                    } else {
                        el.innerHTML = 'Choose a Date';
                        if (startInput) startInput.value = '';
                        if (endInput) endInput.value = '';
                    }
                });

            } catch (e) { console.error('Litepicker init error (notices)', e); }
        });
    }

    // Notices List
    var noticesList = document.querySelector('.notices-api-list');

    var NoticesSearch = {};
    NoticesSearch.HotelID = document.querySelector('.notices-search-hotels') ? document.querySelector('.notices-search-hotels').value : '';
    NoticesSearch.Page = noticesList ? parseInt(noticesList.dataset.page || '0',10) : 0;
    NoticesSearch.PageSize = noticesList ? parseInt(noticesList.dataset.pagesize || '0',10) : 0;
    NoticesSearch.FullCount = 0;
    NoticesSearch.MaxReached = false;
    NoticesSearch.Offers = [];

    // Load More Button
    document.querySelectorAll('.notices-api-load-more').forEach(function(btn){ btn.addEventListener('click', function(){ if (noticesList) noticesList.dataset.page = String((parseInt(noticesList.dataset.page||'0',10)||0)+1); SearchNotices(); }); });

    document.querySelectorAll('.notices-search-form').forEach(function(form){ form.addEventListener('submit', function(e){
        var hotelId = document.getElementById('hotelID');
        var start = document.getElementById('noticeStartDate');
        var end = document.getElementById('noticeEndDate');
        if (hotelId && hotelId.value.length > 0 && start && start.value.length > 0 && end && end.value.length > 0) {
            document.querySelectorAll('.error-validation').forEach(function(el){ el.classList.remove('active'); });
            return true;
        } else {
            document.querySelectorAll('.error-validation').forEach(function(el){ el.classList.add('active'); });
            if (e.preventDefault) e.preventDefault();
            return false;
        }
    }); });

    function SearchNotices() {
        //do an API call to
        var apiUrl = noticesList ? noticesList.dataset.api : '';

        var loadMoreButton = document.querySelector('.notices-api-load-more');
        if (loadMoreButton) loadMoreButton.classList.add('disabled');

        NoticesSearch.Page = noticesList ? parseInt(noticesList.dataset.page || '0',10) : 0;
        NoticesSearch.HotelID = document.querySelector('.notices-search-hotels') ? document.querySelector('.notices-search-hotels').value : '';

        NoticesSearch.NoticesStartDate = document.getElementById('noticeStartDate') ? document.getElementById('noticeStartDate').value : '';
        NoticesSearch.NoticesEndDate = document.getElementById('noticeEndDate') ? document.getElementById('noticeEndDate').value : '';

        // Create the URLs for getting the api data
        var url = apiUrl + "?api=true"
            + (NoticesSearch.Page > 0 ? "&page=" + NoticesSearch.Page : "")
            + (NoticesSearch.PageSize > 0 ? "&pagesize=" + NoticesSearch.PageSize : "")
            + (NoticesSearch.HotelID != "" ? "&hotelID=" + NoticesSearch.HotelID : "")
            + (NoticesSearch.NoticesStartDate != "" ? "&noticeStartDate=" + NoticesSearch.NoticesStartDate : "")
            + (NoticesSearch.NoticesEndDate != "" ? "&noticeEndDate=" + NoticesSearch.NoticesEndDate : "");

        var nextUrl = apiUrl + "?api=true"
            + (NoticesSearch.Page > 0 ? "&page=" + (NoticesSearch.Page + 1) : "")
            + (NoticesSearch.PageSize > 0 ? "&pagesize=" + NoticesSearch.PageSize : "")
            + (NoticesSearch.HotelID != "" ? "&hotelID=" + NoticesSearch.HotelID : "")
            + (NoticesSearch.NoticesStartDate != "" ? "&noticeStartDate=" + NoticesSearch.NoticesStartDate : "")
            + (NoticesSearch.NoticesEndDate != "" ? "&noticeEndDate=" + NoticesSearch.NoticesEndDate : "");

        // Find out if we have more
        fetch(nextUrl).then(function(resp){ return resp.text(); }).then(function(data){

            // Work out if we have reached the max
            NoticesSearch.MaxReached = (data.length < 20);

            fetch(url).then(function(resp){ return resp.text(); }).then(function(data){

                // Append the data to the end of the load more panel
                if (noticesList) noticesList.insertAdjacentHTML('beforeend', data);

                // if the article list page size is 0 then default to 5 for the calculation below
                NoticesSearch.PageSize = NoticesSearch.PageSize == 0 ? 2 : NoticesSearch.PageSize;

                // Remove the more link if we have reached the end
                if (NoticesSearch.MaxReached) {
                    if (loadMoreButton) loadMoreButton.classList.add('hidden-item');
                } else {
                    if (loadMoreButton) loadMoreButton.classList.remove('hidden-item');
                }

                // Re-enable the load more button
                if (loadMoreButton) loadMoreButton.classList.remove('disabled');
            }).catch(function(){ });
        }).catch(function(){ });
    }

    // parse a date string in UK form (DD/MM/YYYY, DD-MM-YYYY, or ISO YYYY-MM-DD)
    function parseUKDate(input) {
        if (!input) return null;
        // accept only the date portion if input may contain time (you already split on space)
        var s = input.trim();
        var parts = s.split(/[\/\-\.]/);
        if (parts.length === 3) {
            // assume DD/MM/YYYY or DD-MM-YYYY
            var d = parseInt(parts[0], 10);
            var m = parseInt(parts[1], 10) - 1;
            var y = parseInt(parts[2], 10);
            return new Date(y, m, d);
        }
        // fallback: try Date constructor (may still be ambiguous)
        return new Date(s);
    }

});
